export default {
  "Connect Wallet": '지갑 연결',
  "Loading":"로드 중...",
  "Purchase Quantity": "구매 수량",
  "Total Amount": "총액",
  "Payment Method": "결제 방법",
  "Fee": "수수료",
  "Purchase": "구매",
  "Select Payment Method": "결제 방법 선택",
  "Language Switch": "언어 스위치",
  "Mall": "쇼핑몰",
  "STAR Purchase": "STAR 구매",
  "Order Details": "주문 상세",
  "My Orders": "내 주문",
  "Order Confirmation Page": "주문 확인 페이지",
  "Product Details": "제품 상세",
  "Store Details": "스토어 상세",
  "Staking MUSE":"스테이킹 MUSE",
  "My Stake":"내 지분",
  "Redeemable Time":"환매 가능 시간",
  "Redeem":"환매하다",
  "Stake":"지분을 걸다",
  "How to Obtain MUSE":"MUSE 얻는 방법",
  "Activity Rules":"활동 규칙",
  "Stake Amount":"지분 금액",
  "Please Enter Amount":"금액을 입력하세요",
  "Balance":"잔액",
  "Redeem Amount":"환매 금액",
  "Confirm":"확인",
  "Cancel":"취소",
  "Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.":"MUSE를 스테이킹하면 StarNest 플랫폼 활동에 대한 투표 수를 늘리고 좋아하는 선수에게 투표할 수 있습니다.",
  "Rule1": "1. MUSE를 스테이킹하여 StarNest 플랫폼 활동의 투표 가중치를 높입니다(해당 활동 설명 참조).",
  "Rule2":"2. 약속된 MUSE는 투자 활동이 종료된 후 언제든지 상환될 수 있습니다.",
  "Rule3":"3. MUSE를 스테이킹하면 플랫폼 거버넌스 및 기타 활동에도 참여할 수 있습니다.",
  "Rule4":"4. 해석의 최종 권리는 StarNest 플랫폼에 있습니다.",
  "Staked":"걸림",
  "Redeemed":"구속됨",
  "Payment":"결제",
  "Next step":"다음 단계",
  "Amount":"금액",
  "Copied":"복사됨",
  "QRCodeTip":"QR 코드를 스캔하거나 주소를 복사하여 주문 금액을 지불하세요. 결제 금액이 부족하면 주문이 실패하고 환불되지 않습니다.",
  "Scan QR code to pay":"결제하려면 QR 코드를 스캔하세요",
  "DownloadTip":"지금 StarNest 앱을 다운로드하고 경험하려면 QR 코드를 스캔하세요",
  "Save QR code":"QR 코드 저장",
  "Minimum":"최저",
  "All":"모두",
  "Failed to create order":"주문을 생성하지 못했습니다.",
  "The order was created successfully and payment is being redirected":"주문이 성공적으로 생성되었으며 결제가 리디렉션되는 중입니다.",
  "Payment details":"결제 세부 정보",
  "Address management":"주소 관리",
  "New address":"새 주소",
  "Delete address":"주소 삭제",
  "Are you sure you want to delete this address?":"이 주소를 삭제하시겠습니까?",
  "First name":"성",
  "Last name":"이름",
  "Please enter":"입력해 주세요",
  "Phone":"전화번호",
  "Country":"국가",
  "State/Province":"시/도",
  "City":"도시",
  "Address":"주소",
  "Zip code":"우편번호",
  "Email":"이메일",
  "Save address":"주소 저장",
  "The address has been edited, do you want to save it?":"주소가 편집되었습니다. 저장하시겠습니까?",
  "Return":"돌아가기",
  "Save":"저장",
  "Waiting for payment":"결제 대기 중",
  "Please complete the payment within time as soon as possible":"{time} 내에 결제를 완료해 주세요",
  "Expired":"만료됨",
  "Order ID":"주문 ID",
  "Order total":"주문 총액",
  "Order time":"주문 시간",
  "Payment method":"결제 방식",
  "Billing address":"청구 주소",
  "Switch address":"주소 변경",
  "Pay":"결제하기",
  "Deleted":"삭제됨",
  "Please fill in the form completely":"양식을 완전히 작성해 주세요",
  "Create success":"생성 성공",
  "Update success":"수정 성공",
  "Insufficient balance":"잔액 부족",
  "No address filled in yet":"아직 주소가 입력되지 않았습니다",
  "Choose country":"국가 선택",
  "Please enter search keywords":"검색 키워드 입력",
  "Payment successful":"결제 성공",
  "Please check the balance in your wallet":"지갑의 잔액을 확인해 주세요",
  "Finish":"완료",
  "Payment failed":"결제 실패",
  "Please complete the payment in time in My Order-Waiting for Payment":"주문-결제 대기 페이지에서 기한 내에 결제를 완료해 주세요",
  "Uploading":"업로드 중",
  "Upload payment voucher":"결제 증명서를 업로드",
  "Submission successful, please check the order later":"제출에 성공했습니다. 나중에 주문을 확인해 주세요",
  "Confirm submission":"제출 확인",
  "Rate tip":"결제 수단에 따라 요금에 환율 차이가 있을 수 있으며, 최종 결제 금액을 기준으로 합니다.",
  "Please log in":"로그인 해주세요",
  "Insufficient product inventory":"상품 재고가 부족합니다",
  "Showtime":"공연 시간",
  "Ticket file":"티켓 파일",
  "Sold out":"매진",
  "Limit tickets per order":"주문당 최대 {num}장",
  "Please select region":"지역을 선택해 주세요",
  "Please fill in the correct email address":"올바른 이메일 주소를 입력해 주세요",
  "Delivery method":"배송 방법",
  "E-ticket":"전자 티켓",
  "Direct entry":"직접 입장",
  "After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher":"결제가 성공하면 티켓을 수령할 필요가 없으며, 티켓 폴더로 가서 입장 증명을 확인하세요",
  "Contact person":"연락처",
  "Name":"이름",
  "Please fill in the contact name":"연락처 이름을 입력해 주세요",
  "Region":"지역",
  "Please enter the mobile number":"휴대폰 번호를 입력해 주세요",
  "Please fill in the email":"이메일을 입력해 주세요",
  "The ticket verification code will be sent to your email via":"티켓 검증 코드는 이메일로 전송됩니다",
  "Details":"세부정보",
  "Submit order":"주문 제출",
  "Price details":"가격 세부정보",
  "The actual discount amount is subject to the following single page":"실제 할인 금액은 다음 주문 페이지에 따릅니다",
  "Product information":"상품 정보",
  "STAR deduction":"STAR 공제",
  "Credit Card":"신용카드",
  "Payment Platform":"결제 플랫폼",
  "On-Chain Payment":"온체인 결제",
  "Other":"기타",
  "No refunds":"환불 불가",
  "Transferable":"양도 가능",
  "Not transferable":"양도 불가",
  "Ended":"끝났다",
  "Countdown":"카운트다운",
  "Please select the ticket file":"티켓 파일을 선택하십시오",
  "Insufficient commodity inventory":"상품 재고가 부족합니다",
  "Please go to log in":"로그인 해주세요",
  "Integral Mall":"일체형 몰",
  "All Products":"모든 제품",
  "Integral Records":"통합 기록",
  "Transaction Details":"거래 세부정보",
  "what": "MUSE란?",
  "museIntro": "MUSE는 Armonia Meta Chain 기반 ARC20 토큰, 총량 21억, 80%는 생태계 채굴로 공급",
  "museUse": "MUSE 활용처",
  "copyrightStaking": "저작권 스테이킹",
  "copyrightStaking1": "아티스트 저작권 NFT(메타버스 AI, 초상 등)에 MUSE 스테이킹하여 수익 분배",
  "vote": "투표",
  "vote1": "MUSE 스테이킹으로 STAR NEST WAR 추가 투표권 획득",
  "product": "특별 상품 구매",
  "product1": "한정판 NFT, 굿즈, 티켓(얼리버드/VIP) 구매",
  "more": "추가 기능(지속 업데이트)",
  "more1": "게임Fi: 라이선스 게임에서 아티스트 IP 사용, MUSE 결제",
  "more2": "아티스트 지원: MUSE로 창작자에게 팁",
  "activity": "특별 이벤트",
  "activity1": "비공개 이벤트 초대권 획득",
  "how": "MUSE 획득 방법",
  "how1": "초기 프라이빗 세일 참여",
  "how2": "콘텐츠 제작 보상",
  "how3": "이벤트(티켓구매, 쇼핑)로 에어드롭 획득",
  "how4": "일부 Audition 작품을 듣거나 보면서 동시에 수익을 얻으세요",
  "Redeem now":"지금 사용하세요",
  "Basic information":"기본 정보",
}